module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header",
    class: [{
      '`skip-links': _vm.accessibilityLinks
    }]
  }, [(_vm.getConsentRequired === 'true' && _vm.hideConsent === false) ? _c('div', {
    staticClass: "app-header-consent background-2-100"
  }, [_c('div', {
    staticClass: "app-header-consent-container"
  }, [_c('div', {
    staticClass: "app-header-consent-content"
  }, [_vm._v("\n        You are yet to give consent for processing your data.\n        Please consent now so you can have access to all website functionalities.\n        You can always read more about this in our\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy-policy'
      }
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "app-header-consent-control"
  }, [_c('button', {
    staticClass: "background-1-50 color-2-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateConsent()
      }
    }
  }, [_vm._v("I Consent")]), _vm._v(" "), _c('button', {
    staticClass: "background-2-16 color-2-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardConsent()
      }
    }
  }, [_vm._v("Not now")])])])]) : _vm._e(), _vm._v(" "), (_vm.getImpersonatingUser !== false) ? _c('div', {
    staticClass: "app-header-consent background-2-100"
  }, [_c('div', {
    staticClass: "app-header-consent-container"
  }, [_c('div', {
    staticClass: "app-header-consent-content"
  }, [_vm._v("\n        You are currently emulating\n        "), (this.impersonate) ? [(this.impersonate.role) ? [_vm._v("\n            " + _vm._s(this.impersonate.role) + " user\n          ")] : _vm._e(), _vm._v(" "), (this.impersonate.firstName) ? [_vm._v("\n            " + _vm._s(this.impersonate.firstName) + "\n          ")] : _vm._e(), _vm._v(" "), (this.impersonate.lastName) ? [_vm._v("\n            " + _vm._s(this.impersonate.lastName) + "\n          ")] : _vm._e()] : _vm._e(), _vm._v("\n         - " + _vm._s(_vm.getImpersonatingUser) + ".\n        Please remember that all your actions will be reflected in the impersonated user account.\n      ")], 2), _vm._v(" "), _c('div', {
    staticClass: "app-header-consent-control"
  }, [_c('button', {
    staticClass: "background-1-50 color-2-100",
    staticStyle: {
      "width": "auto",
      "padding": "0 10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeImpersonate()
      }
    }
  }, [_vm._v("Revert to your account")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-header-main"
  }, [_c('div', {
    staticClass: "admin-header"
  }, [_c('div', {
    staticClass: "app-header-main__container"
  }, [_c('router-link', {
    staticClass: "site-logo",
    class: this.customLogo ? 'industry-logo' : '',
    style: ({
      backgroundImage: this.customLogo ? 'url(' + _vm.getFullServerPath(this.customLogo) + ')' : ''
    }),
    attrs: {
      "to": {
        name: _vm.userDashboard
      },
      "title": "Clear Assured dashboard"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "skip-to-links",
    class: [{
      'active': _vm.accessibilityLinks
    }]
  }, [_c('div', {
    staticClass: "myContainer"
  }, [(_vm.hasSection('sticky-anchors')) ? _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "focus": function($event) {
        _vm.accessibilityLinks = true
      },
      "blur": function($event) {
        _vm.accessibilityLinks = false
      },
      "click": function($event) {
        $event.preventDefault();
        return _vm.skipTo('sticky-anchors')
      }
    }
  }, [_vm._v("Skip to content menu")]) : _vm._e(), _vm._v(" "), (_vm.hasSection('admin-gm-breadcrumbs')) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "focus": function($event) {
        _vm.accessibilityLinks = true
      },
      "blur": function($event) {
        _vm.accessibilityLinks = false
      },
      "click": function($event) {
        $event.preventDefault();
        return _vm.skipTo('admin-gm-breadcrumbs')
      }
    }
  }, [_vm._v("Skip to app menu")]) : _vm._e(), _vm._v(" "), (_vm.isPage(['user-app'])) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "focus": function($event) {
        _vm.accessibilityLinks = true
      },
      "blur": function($event) {
        _vm.accessibilityLinks = false
      },
      "click": function($event) {
        $event.preventDefault();
        return _vm.skipTo('chart-accessibility-table')
      }
    }
  }, [_vm._v("Skip to the company progress chart")]) : _vm._e()])]), _vm._v(" "), (_vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "app-header-description"
  }, [_c('ul', {
    staticClass: "main-menu-header"
  }, [_c('li', {
    staticClass: "dashboard-icon",
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_c('router-link', {
    staticClass: "parent-item",
    attrs: {
      "to": {
        name: 'admin'
      }
    },
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
    staticClass: "tasks-icon",
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_c('router-link', {
    staticClass: "parent-item",
    attrs: {
      "to": {
        name: 'company-tasks',
        params: {
          companyId: 2
        }
      }
    },
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_vm._v("Tasks")])], 1), _vm._v(" "), _c('li', {
    staticClass: "notifications-icon has-children",
    class: [{
      'no-icon': this.unreadNotifications,
      'active': _vm.activeSection === 'notifications'
    }]
  }, [_c('button', {
    staticClass: "parent-item",
    attrs: {
      "aria-expanded": _vm.activeSection === 'notifications' ? 'true' : 'false',
      "aria-controls": "menuNotifications"
    },
    on: {
      "click": function($event) {
        _vm.activeSection === 'notifications' ? _vm.activeSection = '' : _vm.activeSection = 'notifications'
      }
    }
  }, [(this.unreadNotifications) ? _c('span', {
    staticClass: "unread-notifications"
  }, [_vm._v("\n                  " + _vm._s(this.unreadNotifications) + "\n                ")]) : _vm._e(), _vm._v("\n                Notifications\n              ")]), _vm._v(" "), _c('ul', {
    staticClass: "first-level-menu-header notifications",
    attrs: {
      "id": "menuNotifications"
    }
  }, [_c('li', {
    staticClass: "dropdown-info-header"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.markNotificationsRead()
      }
    }
  }, [_vm._v("Mark all as read")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown-info-list"
  }, _vm._l((_vm.notifications), function(item) {
    return _c('ul', {
      staticClass: "dropdown-info-group"
    }, [_c('li', {
      staticClass: "dropdown-info-header"
    }, [_c('span', {
      staticClass: "meta-date"
    }, [_vm._v(_vm._s(_vm.getTodayDate(item.date)))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return _c('li', {
        staticClass: "notification-item",
        class: [{
          'unread': !child.isRead
        }],
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.readNotification(child)
          }
        }
      }, [(child.type === 1) ? [(child.contentId && child.companyId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 2 || child.type === 3) ? [(child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'edit-user',
            params: {
              id: child.userFromId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e(), _vm._v(" "), (!child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'consent-logs'
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 4) ? [(child.contentId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'content',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 5) ? [(_vm.getUserRole === 'gm') ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _c('router-link', {
        attrs: {
          "to": {
            name: 'task',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))])] : [_vm._v("\n                        " + _vm._s(child.message) + "\n                      ")]], 2)
    })], 2)
  }), 0), _vm._v(" "), _c('li', {
    staticClass: "see-all"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'notifications'
      }
    }
  }, [_vm._v("See all notifications")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "content-icon has-children",
    class: {
      'active': _vm.activeSection === 'content'
    }
  }, [_c('button', {
    staticClass: "parent-item",
    attrs: {
      "aria-expanded": _vm.activeSection === 'content' ? 'true' : 'false',
      "aria-controls": "menuContent"
    },
    on: {
      "click": function($event) {
        _vm.activeSection === 'content' ? _vm.activeSection = '' : _vm.activeSection = 'content'
      }
    }
  }, [_vm._v("Content")]), _vm._v(" "), _c('ul', {
    staticClass: "first-level-menu-header",
    attrs: {
      "id": "menuContent"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'todo-list'
      }
    }
  }, [_vm._v("Tasks")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'chapters'
      }
    }
  }, [_vm._v("Task categories")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'articles-list'
      }
    }
  }, [_vm._v("Resources")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'categories'
      }
    }
  }, [_vm._v("Resource categories")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'tags'
      }
    }
  }, [_vm._v("Topics")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'industries'
      }
    }
  }, [_vm._v("Industries")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit-pages-list'
      }
    }
  }, [_vm._v("Landing pages")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'default-email-templates'
      }
    }
  }, [_vm._v("Email templates")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard-promotions'
      }
    }
  }, [_vm._v("Dashboard promotions")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'redirects'
      }
    }
  }, [_vm._v("Redirects")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "users-icon has-children",
    class: {
      'active': _vm.activeSection === 'users'
    }
  }, [_c('button', {
    staticClass: "parent-item",
    attrs: {
      "aria-expanded": _vm.activeSection === 'users' ? 'true' : 'false',
      "aria-controls": "menuUsers"
    },
    on: {
      "click": function($event) {
        _vm.activeSection === 'users' ? _vm.activeSection = '' : _vm.activeSection = 'users'
      }
    }
  }, [_vm._v("Users")]), _vm._v(" "), _c('ul', {
    staticClass: "first-level-menu-header",
    attrs: {
      "id": "menuUsers"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("Users")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("Companies")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "logs-icon",
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_c('router-link', {
    staticClass: "parent-item",
    attrs: {
      "to": {
        name: 'logs'
      }
    },
    on: {
      "focus": function($event) {
        _vm.activeSection = ''
      }
    }
  }, [_vm._v("Logs")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.getUserRole !== 'gm') ? _c('div', {
    staticClass: "front-header-tagline",
    attrs: {
      "aria-label": 'In association with: ' + _vm.industriesAlts
    }
  }, [_c('div', {
    staticClass: "front-header-tagline_text background-1-100",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(this.customLogo) ? [_vm._v("Powered by")] : [_vm._v("In association with")]], 2), _vm._v(" "), _c('div', {
    staticClass: "industry-logos",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(this.customLogo) ? [_c('router-link', {
    staticClass: "front-header-logo",
    attrs: {
      "to": "/",
      "title": "The Clear Company logo"
    }
  }, [_c('img', {
    staticClass: "clearLogo",
    attrs: {
      "src": require("../../assets/img/svg/logo.svg"),
      "alt": "The Clear Company logo"
    }
  })])] : [_vm._l((_vm.sponsors), function(row, index) {
    return [(row.url) ? [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      attrs: {
        "href": row.url,
        "aria-label": row.altImage,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "sponsorLogo",
      attrs: {
        "src": _vm.getImageFullPath(row.logo),
        "alt": " "
      }
    })]) : _vm._e()] : [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      attrs: {
        "href": "#",
        "aria-label": row.altImage
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('img', {
      staticClass: "sponsorLogo",
      attrs: {
        "src": _vm.getImageFullPath(row.logo),
        "alt": " "
      }
    })]) : _vm._e()]]
  })]], 2)]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "app-header-info background-1-20"
  }, [_c('div', {
    staticClass: "admin-header"
  }, [_c('div', {
    staticClass: "app-header-info__container"
  }, [_c('div', {
    staticClass: "app-header-menus"
  }, [_c('button', {
    staticClass: "mobile-menu-trigger background-1-100-after",
    class: [{
      'active': this.mobileMenuShown
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openSubmenu($event, 'mobileMenu')
      }
    }
  }, [_c('div', {
    staticClass: "mobile-menu-trigger__icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-bars fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "bars",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Menu")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu-trigger__arrow"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "app-header-login main-menu-regular",
    class: [{
      'mobile-active': this.mobileMenuShown
    }]
  }, [(_vm.isRegularUser) ? _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('span', {
    staticClass: "menu-icon dashboard",
    class: [{
      'color-1-80': !_vm.activePage('/dashboard'),
      'background-1-100': _vm.activePage('/dashboard')
    }]
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-home fa-w-18",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "home",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 576 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
    }
  })])]), _vm._v("\n                Dashboard\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isRegularUser || _vm.isLightUser) ? _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": {
        name: 'knowledge-base'
      }
    }
  }, [_c('span', {
    staticClass: "menu-icon knowledge-base",
    class: [{
      'color-1-80': !_vm.activePage('/knowledge-base'),
      'background-1-100': _vm.activePage('/knowledge-base')
    }]
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-book fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "book",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
    }
  })])]), _vm._v("\n                Inclusion hub\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isRegularUser) ? _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": {
        name: 'tasks'
      }
    }
  }, [_c('span', {
    staticClass: "menu-icon tasks",
    class: [{
      'color-1-80': !_vm.activePage('/tasks'),
      'background-1-100': _vm.activePage('/tasks')
    }]
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-stream fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "stream",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
    }
  })])]), _vm._v("\n                Tasks\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isRegularUser || _vm.isLightUser) ? _c('li', {
    staticClass: "notifications-icon has-children",
    class: [{
      'no-icon': this.unreadNotifications,
      'active border-1-70': _vm.activeSection === 'notifications'
    }]
  }, [_c('button', {
    staticClass: "parent-item menu-link background-1-70-after",
    attrs: {
      "aria-expanded": _vm.activeSection === 'notifications' ? 'true' : 'false',
      "aria-controls": "menuNotifications"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activeSection === 'notifications' ? _vm.activeSection = '' : _vm.activeSection = 'notifications'
      }
    }
  }, [_c('span', {
    staticClass: "menu-icon notifications"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-bell fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "bell",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
    }
  })])]), _vm._v(" "), (this.unreadNotifications) ? _c('span', {
    staticClass: "unread-notifications"
  }, [_vm._v("\n                  " + _vm._s(this.unreadNotifications) + "\n                ")]) : _vm._e(), _vm._v("\n                Notifications\n              ")]), _vm._v(" "), _c('ul', {
    staticClass: "first-level-menu-header notifications border-1-70",
    class: [{
      'active': _vm.activeSection === 'notifications'
    }],
    attrs: {
      "id": "menuNotifications"
    }
  }, [(_vm.notifications && _vm.notifications.length) ? _c('li', {
    staticClass: "dropdown-info-header",
    class: {
      'no-notifications': !_vm.unreadNotifications
    }
  }, [(_vm.unreadNotifications) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.markNotificationsRead()
      }
    }
  }, [_vm._v("\n                    Mark all as read\n                  ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.notifications && _vm.notifications.length) ? _c('li', {
    staticClass: "dropdown-info-list"
  }, _vm._l((_vm.notifications), function(item) {
    return _c('ul', {
      staticClass: "dropdown-info-group"
    }, [_c('li', {
      staticClass: "dropdown-info-header"
    }, [_c('span', {
      staticClass: "meta-date"
    }, [_vm._v(_vm._s(_vm.getTodayDate(item.date)))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return _c('li', {
        staticClass: "notification-item",
        class: [{
          'unread': !child.isRead
        }],
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.readNotification(child)
          }
        }
      }, [(child.type === 1) ? [(child.contentId && child.companyId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 2 || child.type === 3) ? [(child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'edit-user',
            params: {
              id: child.userFromId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e(), _vm._v(" "), (!child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'consent-logs'
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 4) ? [(child.contentId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'content',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 5) ? [(_vm.getUserRole === 'gm') ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _c('router-link', {
        attrs: {
          "to": {
            name: 'task',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))])] : [_vm._v("\n                        " + _vm._s(child.message) + "\n                      ")]], 2)
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.notifications && _vm.notifications.length) ? _c('li', {
    staticClass: "see-all border-1-70"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard-notifications'
      }
    }
  }, [_vm._v("See all notifications")])], 1) : _vm._e(), _vm._v(" "), (!_vm.notifications || !_vm.notifications.length) ? _c('li', {
    staticClass: "dropdown-info-list-empty"
  }, [_vm._v("\n                  There are no notifications.\n                ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isRegularUser || _vm.isLightUser) ? _c('li', {
    staticClass: "notifications-icon notifications-icon-mobile"
  }, [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": {
        name: 'dashboard-notifications'
      }
    }
  }, [_c('span', {
    staticClass: "menu-icon notifications"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-bell fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "bell",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
    }
  })])]), _vm._v(" "), (this.unreadNotifications) ? _c('span', {
    staticClass: "unread-notifications"
  }, [_vm._v("\n                  " + _vm._s(this.unreadNotifications) + "\n                ")]) : _vm._e(), _vm._v("\n                Notifications\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isRegularUser || _vm.isLightUser) ? _c('li', {
    staticClass: "has-dropdown",
    class: [{
      'opened border-1-70': _vm.menuShown === 'myCompany',
      'background-1-10': _vm.mobileMenuShown && _vm.menuShown === 'myCompany' && !_vm.getDeviceType('desktop')
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('a', {
    staticClass: "color-2-100 background-1-70-after",
    attrs: {
      "href": "#",
      "title": "Open menu"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSubmenu($event, 'myCompany')
      }
    }
  }, [_c('span', {
    staticClass: "app-header-login-icon-before sf-color-1-60"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-briefcase fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "briefcase",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("My company")]), _vm._v(" "), _c('span', {
    staticClass: "app-header-login-icon-after sf-color-1-60"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "app-header-login__dropdown border-1-70"
  }, [_c('li', [_c('router-link', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "to": {
        name: 'company-subscription'
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "12",
      "height": "16.031",
      "viewBox": "0 0 12 16.031"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12.188.094a.473.473,0,0,1,.531-.047A.473.473,0,0,1,13,.5v15a.509.509,0,0,1-.812.406L11,14.5,9.313,15.906a.5.5,0,0,1-.625,0L7,14.5,5.313,15.906a.5.5,0,0,1-.625,0L3,14.5,1.813,15.906a.473.473,0,0,1-.531.047A.473.473,0,0,1,1,15.5V.5A.473.473,0,0,1,1.281.047a.473.473,0,0,1,.531.047L3,1.5,4.688.094a.5.5,0,0,1,.625,0L7,1.5,8.688.094a.5.5,0,0,1,.625,0L11,1.5ZM10.5,11.5A.442.442,0,0,0,11,11a.442.442,0,0,0-.5-.5h-7A.442.442,0,0,0,3,11a.442.442,0,0,0,.5.5Zm0-3A.442.442,0,0,0,11,8a.442.442,0,0,0-.5-.5h-7A.442.442,0,0,0,3,8a.442.442,0,0,0,.5.5Zm0-3A.442.442,0,0,0,11,5a.442.442,0,0,0-.5-.5h-7A.442.442,0,0,0,3,5a.442.442,0,0,0,.5.5Z",
      "transform": "translate(-1 0.016)"
    }
  })])]), _vm._v("\n                    Company subscription\n                  ")])], 1), _vm._v(" "), _c('li'), (_vm.isRegularUser) ? _c('li', [_c('router-link', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "to": {
        name: 'company-profile'
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "16",
      "viewBox": "0 0 14 16"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M13.5,14.5a.442.442,0,0,1,.5.5v.5a.442.442,0,0,1-.5.5H8V12.5a.442.442,0,0,0-.5-.5h-1a.442.442,0,0,0-.5.5V16H.5a.442.442,0,0,1-.5-.5V15a.442.442,0,0,1,.5-.5H1V.75A.723.723,0,0,1,1.219.219.723.723,0,0,1,1.75,0h10.5a.723.723,0,0,1,.531.219A.723.723,0,0,1,13,.75V14.5ZM6,9.5v-1A.442.442,0,0,0,5.5,8h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,6,9.5Zm0-3v-1A.442.442,0,0,0,5.5,5h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,6,6.5Zm0-3v-1A.442.442,0,0,0,5.5,2h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,6,3.5Zm4,6v-1A.442.442,0,0,0,9.5,8h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,10,9.5Zm0-3v-1A.442.442,0,0,0,9.5,5h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,10,6.5Zm0-3v-1A.442.442,0,0,0,9.5,2h-1a.442.442,0,0,0-.5.5v1a.442.442,0,0,0,.5.5h1A.442.442,0,0,0,10,3.5Z"
    }
  })])]), _vm._v("\n                    Company profile\n                  ")])], 1) : _vm._e(), _vm._v(" "), _c('li', [(_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta' || _vm.getUserRole === 'la') ? _c('router-link', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "to": {
        name: 'ca-users'
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "16",
      "viewBox": "0 0 20 16"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12.3-4.953A3.131,3.131,0,0,1,10-4a3.131,3.131,0,0,1-2.3-.953,3.131,3.131,0,0,1-.953-2.3,3.131,3.131,0,0,1,.953-2.3A3.131,3.131,0,0,1,10-10.5a3.131,3.131,0,0,1,2.3.953,3.131,3.131,0,0,1,.953,2.3A3.131,3.131,0,0,1,12.3-4.953ZM11.563-3a4.436,4.436,0,0,1,3.125,1.219A3.866,3.866,0,0,1,16,1.156a.788.788,0,0,1-.266.594.864.864,0,0,1-.609.25H4.875a.864.864,0,0,1-.609-.25A.788.788,0,0,1,4,1.156,3.866,3.866,0,0,1,5.313-1.781,4.436,4.436,0,0,1,8.438-3Zm6.2-6.734A2.407,2.407,0,0,1,16-9a2.407,2.407,0,0,1-1.766-.734A2.407,2.407,0,0,1,13.5-11.5a2.407,2.407,0,0,1,.734-1.766A2.407,2.407,0,0,1,16-14a2.407,2.407,0,0,1,1.766.734A2.407,2.407,0,0,1,18.5-11.5,2.407,2.407,0,0,1,17.766-9.734ZM5.75-7.25A4.224,4.224,0,0,0,6.781-4.5H.563a.524.524,0,0,1-.406-.172A.6.6,0,0,1,0-5.094,2.907,2.907,0,0,1,.8-7.141,2.561,2.561,0,0,1,2.75-8H4.688a2.75,2.75,0,0,1,1.125.25A2.689,2.689,0,0,0,5.75-7.25Zm.016-2.484A2.407,2.407,0,0,1,4-9a2.407,2.407,0,0,1-1.766-.734A2.407,2.407,0,0,1,1.5-11.5a2.407,2.407,0,0,1,.734-1.766A2.407,2.407,0,0,1,4-14a2.407,2.407,0,0,1,1.766.734A2.407,2.407,0,0,1,6.5-11.5,2.407,2.407,0,0,1,5.766-9.734ZM17.25-8a2.561,2.561,0,0,1,1.953.859A2.907,2.907,0,0,1,20-5.094a.6.6,0,0,1-.156.422.524.524,0,0,1-.406.172H13.219A4.224,4.224,0,0,0,14.25-7.25a3.835,3.835,0,0,0-.062-.5A2.75,2.75,0,0,1,15.313-8Z",
      "transform": "translate(0 14)"
    }
  })])]), _vm._v("\n                    Users\n                  ")]) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "app-header-right-menus"
  }, [_c('ul', {
    staticClass: "app-header-login"
  }, [_c('li', {
    staticClass: "has-dropdown",
    class: [{
      'opened border-1-70': _vm.menuShown === 'login',
      'background-1-10': _vm.mobileMenuShown && _vm.menuShown === 'login' && !_vm.getDeviceType('desktop')
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('a', {
    staticClass: "color-2-100 background-1-70-after",
    attrs: {
      "href": "#",
      "title": "Open menu"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSubmenu($event, 'login')
      }
    }
  }, [_c('span', {
    staticClass: "app-header-login-icon-before sf-color-1-60"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 11.096 14.417"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 11.096 14.417",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_497_",
      "cx": "5.548",
      "cy": "3.75",
      "r": "3.75"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_496_",
      "d": "M1.002,14.417c-0.619,0-1.087-0.558-0.989-1.17c0.442-2.766,2.492-4.455,5.535-4.455\n                      s5.093,1.69,5.535,4.455c0.098,0.611-0.37,1.17-0.989,1.17H1.002z"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v(_vm._s(_vm.getCustomUserName()))]), _vm._v(" "), _c('span', {
    staticClass: "app-header-login-icon-after sf-color-1-60"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])]), _vm._v(" "), (_vm.getIsLoggedIn) ? [_c('ul', {
    staticClass: "app-header-login__dropdown border-1-70",
    staticStyle: {
      "left": "unset",
      "right": "0"
    }
  }, [_c('li', [_c('router-link', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-user-circle fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "user-circle",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 496 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    }
  })])]), _vm._v("\n                        My profile\n                      ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "to": {
        name: 'email-preferences'
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-envelope fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "envelope",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
    }
  })])]), _vm._v("\n                        My email preferences\n                      ")])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "app-header-login__item app-header-login__item--name has-icon color-2-100 background-1-20-hover",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.authLogout($event)
      }
    }
  }, [_c('div', {
    staticClass: "app-header-login__item--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-sign-out-alt fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "sign-out-alt",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
    }
  })])]), _vm._v("\n                        Logout\n                      ")])])])] : [_c('router-link', {
    staticClass: "app-header-login__item color-2-100",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Login")])]], 2)])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "feedback-button",
    on: {
      "click": function($event) {
        return _vm.activateFeedback()
      }
    }
  }, [_c('span', [_vm._v("Send us your Feedback")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d455b562","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AppHeader.vue
// module id = 996
// module chunks = 1